/**
 * @typedef {Object} UserData
 * @property {string} name - The full name of the user
 */

/**
 * @typedef {Object} User
 * @property {string} name - The full name of the user
 * @property {string} email - The email address of the user
 */

/** @type {Record<string, UserData>} */
const usersMap = {
  'm.fernandez@okb.es': {
    name: 'Marina Fernandez'
  },
  'j.espinosa@okb.es': {
    name: 'Jose Espinosa'
  },
  'c.toribio@okb.es': {
    name: 'Carlos Toribio'
  },
  'c.rodriguez@okb.es': {
    name: 'Cristina Rodriguez'
  },
  'c.lahoz@okb.es': {
    name: 'Carolina Lahoz'
  },
  'r.pineda@okb.es': {
    name: 'Raúl Pineda'
  },
  'g.gomez@okb.es': {
    name: 'Griselda Gomez'
  },
  'a.gonzalez@okb.es': {
    name: 'Amaya Gonzalez'
  },
  'j.arroyo@okb.es': {
    name: 'Jorge Arroyo'
  },
  'a.saez-benito@okb.es': {
    name: 'Ana Saez-Benito'
  },
  'h.garcia@okb.es': {
    name: 'Helena Garcia'
  },
  's.fontan@okb.es': {
    name: 'Sergio Fontan'
  }
}

/**
 * Get a user by their email address
 * @param {string} email
 * @returns {User | undefined}
 */
export const getUser = (email) => {
  const userData = usersMap[email]
  return userData ? { ...userData, email } : undefined
}

export default usersMap
